import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { QueryClientProvider } from '@tanstack/react-query'

import App from '@/app/App'
import { queryClient } from '@/routes/Router'
import { initSentry } from '@/shared/sentry/init'

initSentry()

const rootElement = document.getElementById('root') as HTMLElement

const element = (
  <StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </StrictMode>
)
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, element)
} else {
  createRoot(rootElement).render(element)
}
